import i18n from '@i18n';
import { POST_ANALYSIS, POST_TICKET } from 'nike-ui/src/components/betbook/constants';

export function getPostTitle(postType) {
    if (postType === POST_ANALYSIS) return `${i18n('react.page.title.page::analysisDetail')}: `;
    if (postType === POST_TICKET) return `${i18n('jsp.KurzovaPonuka.Tiket')}: `;
    return `${i18n('betbook.newPost.type.article')}: `;
}
